"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "C"];